module.exports = __webpack_public_path__ + "static/media/yuce019.5527257b.jpg";